import { render, staticRenderFns } from "./WorkTaskKanbanColumn.vue?vue&type=template&id=3615f068&scoped=true"
import script from "./WorkTaskKanbanColumn.vue?vue&type=script&lang=ts"
export * from "./WorkTaskKanbanColumn.vue?vue&type=script&lang=ts"
import style0 from "./WorkTaskKanbanColumn.vue?vue&type=style&index=0&id=3615f068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3615f068",
  null
  
)

export default component.exports